import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { appName } from 'app/app.config';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-footer',
    imports: [CommonModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: true,
})
export class FooterComponent {
    /**
     * App Name
     */
    name = appName;

    /**
     * App Version
     */
    version = environment.version;

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }
}
